var _path, _g, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdcbep20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4EAF94",
    d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2775CA",
    d: "M12 24a12 12 0 1 0 0-24 12 12 0 1 0 0 24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5 9.5a7.4 7.4 0 0 0 4.5 9.6c.1.1.3.3.3.5v.7l-.1.2c0 .2-.2.3-.4.2a9 9 0 0 1 0-17.2h.2c.2 0 .3.2.3.4v.7c0 .3-.1.4-.3.5-2.1.7-3.7 2.3-4.5 4.4Zm9.3-5.8c0-.2.3-.3.5-.2 2.7 1 4.9 3.1 5.8 6a9 9 0 0 1-5.8 11.3h-.2c-.2 0-.3-.2-.3-.4v-.7c0-.3 0-.4.3-.5a7.4 7.4 0 0 0 0-14l-.3-.6V3.7Zm-2.1 7.6c2 .2 3.1.8 3.1 2.6 0 1.3-1 2.4-2.5 2.6v1.2c0 .3-.2.4-.4.4h-.7c-.3 0-.4-.2-.4-.4v-1.2c-1.7-.2-2.5-1.1-2.7-2.4 0-.2.2-.4.4-.4h.8c.2 0 .3.1.4.3.1.8.6 1.3 1.9 1.3.9 0 1.6-.5 1.6-1.3s-.4-1.1-1.8-1.4c-2.1-.2-3.1-.9-3.1-2.5 0-1.3.9-2.3 2.4-2.5V6.5c0-.3.2-.4.4-.4h.8c.2 0 .4.2.4.4v1.2c1.1.1 2 1 2.2 2v.1c0 .2-.1.3-.3.3h-.8a.4.4 0 0 1-.4-.2c-.2-.8-.7-1-1.6-1-1 0-1.5.4-1.5 1.1 0 .7.3 1.1 1.8 1.3Z",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M-3 14h29v7H-3z",
    opacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.2 19.3H6v.2h-.3v.3h-.2v.2H3v-5h2.5v.2h.2v.3H6v.2h.2v1.1H6v.2h-.3v.3h-.2v.2h.2v.2H6v.3h.2v1.3Zm-.7-2.7v-.7h-.3v-.2H3.7V17H5v-.2h.2v-.2h.3Zm0 2.5v-1h-.3V18H5v-.3H3.7v1.6h1.5v-.2h.3ZM9.9 20H6.7v-5h3.2v.7H7.4V17h2v.7h-2v1.6H10v.7ZM13.6 17.3h-.2v.2H13v.2H13v.3H11v2h-.7v-5h2.5v.2h.2v.3h.3v.2h.2v1.6Zm-.7-.3v-1h-.3v-.3h-1.5v1.6h1.5V17h.3ZM17.3 20h-3.2v-1.8h.2V18h.3v-.3h.2v-.2h.3v-.2h1V17h.2v-.2h.3V16h-.3v-.2h-1.2v.2h-.3v.5h-.7v-.7h.2v-.2h.3v-.3h.2V15h1.8v.2h.2v.3h.3v.2h.2V17h-.2v.3h-.3v.2h-.2v.2h-.3v.3h-1v.2h-.2v.2h-.3v1h2.5v.6ZM21 19h-.2v.3h-.3v.2h-.2v.3H20v.2h-1.2v-.2h-.3v-.3h-.2v-.2H18v-.2h-.2v-3.2h.2v-.2h.3v-.2h.2v-.3h.3V15H20v.2h.3v.3h.2v.2h.3v.2h.2v3.2Zm-1-2.9v-.4h-1.2v.2h-.3v2.5h.3V18h.2v-.5h.3V17h.2v-.4h.3V16h.2Zm.3 3v-2.3H20v.5h-.2v.4h-.3v.5h-.2v.4H19v.5h-.2v.2H20v-.2h.3Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff",
    rx: 12
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdcbep20);
export default __webpack_public_path__ + "static/media/USDCBEP20.c66fc0020a0493b54db4a1a966369279.svg";
export { ForwardRef as ReactComponent };